import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import i18next from "i18next";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import PlaceholderWrapper from "../../Common/PlaceholderWrapper";
import ITEquipment from "./components/ITEquipment";
import RequestForm from "./components/RequestForm";
import {ITEquipmentControl} from "./components/ITEquipmentControl";
import SearchBar from "@mnjsplatform/components/lib/common/SearchBar";

class SubRemoteWork extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            showITForm: false,
            stateRuleCode: null,
            showRequestForm: false
        };
    }

    componentDidMount() {
        this.initialize();
    }

    initialize = async () => {
        //await this.props.dispatch(this.props.dataItem_Filters.execute());
        await this.props.dispatch(this.props.dataItem_List.execute({}, {withParams: true, withStyle: true}));
        await this.props.dispatch(this.props.dataItem_List.treeOperationByLevel(0, true));
        await this.props.dispatch(this.props.dataItem_GetButtonForPO.execute());
    }
    renderParams = (h) => {
        return (<>
            <div className="row">
                <div className="col-3 field-title text-left">{h.lbl('AdmStructName')}</div>
                <div className="col-9">{h.ed('AdmStructName')}</div>
            </div>
            <div className="row">
                <div className="col-3 field-title text-left">{h.lbl('IncludeSub')}</div>
                <div className="col-3">{h.ed('IncludeSub')}</div>
                <div className="col-3 field-title text-left">{h.lbl('ProfessionEd')}</div>
                <div className="col-3">{h.ed('ProfessionEd')}</div>
            </div>
            <div className="row">
                <div className="col-3 field-title text-left">{h.lbl('AddressEd')}</div>
                <div className="col-3">{h.ed('AddressEd')}</div>
                <div className="col-3 field-title text-left">{h.lbl('TypeTabCalEd')}</div>
                <div className="col-3">{h.ed('TypeTabCalEd')}</div>
            </div>
            <div className="row">
                <div className="col-3 field-title text-left">{h.lbl('IsRemoteSet')}</div>
                <div className="col-3">{h.ed('IsRemoteSet')}</div>
                <div className="col-3 field-title text-left">{h.lbl('IsRemoteNotSet')}</div>
                <div className="col-3">{h.ed('IsRemoteNotSet')}</div>
            </div>
            <div className="row">
                <div className="col-3 field-title text-left">{h.lbl('IsRemoteTypeConst')}</div>
                <div className="col-3">{h.ed('IsRemoteTypeConst')}</div>
                <div className="col-3 field-title text-left">{h.lbl('IsRemoteTypeTime')}</div>
                <div className="col-3">{h.ed('IsRemoteTypeTime')}</div>
            </div>
            <div className="row">
                <div className="col-1">
                    {i18next.t("Search_By_FIO")}:
                </div>
                <div className="col-10">
                    <SearchBar dataItem={this.props.dataItem_List} autoFields={false} fieldSet={['DisplayName']}/>
                </div>
            </div>
        </>)
    }
    refresh = async () => {
        await this.props.dispatch(this.props.dataItem_List.refresh());
    }
    /*
        saveParams = async () => {
            await this.props.dispatch(this.props.dataItem_Filters.save(0));
        }
    */
    selectValue = async (e, rowParams) => {
        if (e) e.preventDefault();
        await this.props.dispatch(rowParams.dataItem.setField(rowParams.rowIndex, 'IsSet', (rowParams.row.IsSet === 1 ? 0 : 1)));
        await this.props.dispatch(rowParams.dataItem.save(rowParams.rowIndex));
    }

    resetAll = async (dataItem) => {
        for (let i = 0; i < dataItem.rowsCount(); i++) {
            await this.props.dispatch(dataItem.setField(i, 'IsSet', 0));
            await this.props.dispatch(dataItem.save(i));
        }
    }

    setAll = async (dataItem) => {
        for (let i = 0; i < dataItem.rowsCount(); i++) {
            await this.props.dispatch(dataItem.setField(i, 'IsSet', 1));
            await this.props.dispatch(dataItem.save(i));
        }
    }
    renderSubgridPanelButtons = (dataItem, onClose) => {
        return <div className="modal-footer text-right">
            <button type="button" className="btn btn-regular -goahead" data-dismiss="modal"
                    onClick={() => this.resetAll(dataItem)}>{i18next.t('ResetAll')}</button>
            <button type="button" className="btn btn-regular -goahead" data-dismiss="modal"
                    onClick={() => this.setAll(dataItem)}>{i18next.t('SetAll')}</button>
            <button type="button" className="btn btn-regular -default" data-dismiss="modal"
                    onClick={onClose}>{i18next.t('Close')}</button>
        </div>
    }
    renderSubgridRowEx = (rowParams) => {
        let value;
        const values = {
            'RemoteWorkPO.SelAddress': rowParams.row.AddressName,
            'RemoteWorkPO.SelProfessionSet': rowParams.row.ProfessionName,
            'RemoteWorkPO.SelTabCalSet': rowParams.row.TypeTabCalName
        };
        value = values[rowParams.dataItem.rawData.ItemId] || rowParams.row.AddressName;
        return (
            <div style={{cursor: "pointer"}} key={rowParams.rowIndex}
                 onClick={(e) => this.selectValue(e, rowParams)}>
                <input type="checkbox" className="checkbox" checked={rowParams.row["IsSet"] === 1}
                       style={{cursor: "pointer"}} onChange={() => {
                }}/>&nbsp;
                {value}
            </div>
        )
    }
    contentContainerStyleProvider = ({mobileMode}) => {
        if (!mobileMode) {
            let height = 400;
            return {
                minHeight: "150px", height: height + "px"
            };
        }
    }

    renderCellEx = (cellParams) => {
        if (cellParams.fieldInfo.Name === "StateRuleCode" && cellParams.row[cellParams.fieldInfo.Name]) {
            const formParams = Object.assign({}, cellParams, {
                onClick: (event) => {
                    this.setState({showITForm: true, stateRuleCode: cellParams.row[cellParams.fieldInfo.Name]});
                }});
            return (<ITEquipmentControl {...formParams} />)
                /*<div>
                    <label>
                        <a href="#" rel="noopener noreferrer"
                           onClick={(event) => {
                               this.setState({showITForm: true, stateRuleCode: cellParams.row[cellParams.fieldInfo.Name]});
                           }}
                           className="mr-2">{i18next.t('Просмотр')}</a>
                    </label>
                </div>)*/;
        }
        return cellParams.renderCellDefault(cellParams.row, cellParams.fieldInfo, cellParams.fieldIndex);
    }

    showRequestForm = () => {
        this.setState({showRequestForm: true});
    }
    renderButtons = (buttonInfo) => {
        if (!buttonInfo) {
            return null;
        }
        return (
            <div className="modal-header text-left">
                    {buttonInfo.IsShow === 1 &&
                        <button type="button" className="btn btn-regular -goahead ml1ex" title={buttonInfo.Caption}
                                onClick={this.showRequestForm}>{buttonInfo.Caption}</button>}
            </div>
        )
    }

    getCellStyleProvider = (dataItem, rowIndex, fieldInfo) => {
        let cellStyle = {};
        const fieldIndex = dataItem.rawData.ResultFieldInfo.indexOf(dataItem.rawData.ResultFieldInfo.find(fi => fi.Name === fieldInfo.Name));
        if(fieldIndex % 2 === 0){
            cellStyle = {
                ...cellStyle, backgroundColor: 'rgb(241, 241, 241)'
            };
        }
        return cellStyle;
    }
    getRowStyleProvider = (rowIndex, row) => {
        let style = {};
        if (row.NodeType === 'StateRule') {
            return {
                ...style, fontWeight: "bold"
            };
        }
        return style;
    }

    render() {
        if (!this.props.dataItem_List.isInitialized || !this.props.dataItem_GetButtonForPO.isInitialized) {
            return null;
        }
        const buttonInfo = this.props.dataItem_GetButtonForPO.getRow(0);
        return (<>
            <PlaceholderWrapper placeholderId="10" title={i18next.t("SubRemoteWork_1")}
                                canCollapse={false}>
                <PlaceholderWrapper placeholderId="20" title={i18next.t("Filters")} canCollapse={true}
                                    showSplitterLine={false} collapsed={true}>
                    <ComplexParam dataItem={this.props.dataItem_List_Params}
                                  parentDataItem={this.props.dataItem_List}
                                  renderParams={this.renderParams}
                                  showApplyButton={false} autoApplyParams={true}
                                  showSubgridHeader={false}
                                  renderSubgridRowEx={this.renderSubgridRowEx}
                                  renderSubgridPanelButtons={this.renderSubgridPanelButtons}
                                  maxSubgridWidthBody=""
                                  autoFocusField="AdmStructName"
                                  showSearchBar={false}
                                  rootPath="/"/>
                </PlaceholderWrapper>
                {this.renderButtons(buttonInfo)}

                <div id="EmployeesBlock" className="card"
                     aria-labelledby="Employees-tab">
                    <GridView dataItem={this.props.dataItem_List}
                              fixHeader={true} readOnly={true}
                              //contentContainerStyleProvider={this.contentContainerStyleProvider}
                              renderCellEx={this.renderCellEx} autoLoadRows={true} showMoreRowsBtnWhenAutoLoad={false}
                              cellStyleProvider={this.getCellStyleProvider}
                              rowStyleProvider={this.getRowStyleProvider}
                              pageSize={10} allowPagination={true} activePageSize={5} rowCursor="pointer"/>
                </div>
                {/*<div id="EmployeesBlock2" className="inwhite card"><SubRemoteGrid dataItem={this.props.dataItem_List}/></div>*/}
            </PlaceholderWrapper>
            {this.state.showITForm && <ITEquipment stateRuleCode={this.state.stateRuleCode} readOnly={true}
                                                   onClose={() => {
                this.setState({showITForm: false})
            }}/>}
            {this.state.showRequestForm && <RequestForm title={buttonInfo.Header} readOnly={true}
                                                   onClose={() => {
                                                       this.setState({showRequestForm: false})
                                                   }}/>}
        </>);
    }
}

SubRemoteWork.propTypes = {
    dispatch: PropTypes.func.isRequired,
    dataItem_Filters: PropTypes.object,
    dataItem_List: PropTypes.object,
    dataItem_List_Params: PropTypes.object,
    dataItem_GetButtonForPO: PropTypes.object
}
SubRemoteWork.defaultProps = {};
function mapStateToProps(state, ownProps) {
    return {
        dataItem_Filters: state.subRemoteWorkState.RemoteWorkPO_FiltersForPO,
        dataItem_List: state.subRemoteWorkState.RemoteWorkPO_ListSubForPO_Tree,
        dataItem_List_Params: state.subRemoteWorkState.RemoteWorkPO_ListSubForPO_Tree_Params,
        dataItem_GetButtonForPO: state.subRemoteWorkState.RemoteWorkHardwareSet_GetButtonForPO
    }
}
export default connect(mapStateToProps)(SubRemoteWork)